<template>
  <div class="">
    <head-nav-bar title="地图导航" :fixed="true" />
    <div class="doctor-info mt-header-nav">
      <div class="map-box">
        <Map v-model="center" style="height:calc(100vh - 80px)" />
        <div class="map-text">
          <div class="text-info">
            <div>{{ hospitalInfo.ContactPersonPhone }}</div>
            <div>{{ hospitalInfo.Address }}</div>
          </div>
        </div>
        <div class="bg"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";

import Map from "@/components/Map";
export default {
  name: "hospitalIndex",
  components: {
    Map,
  },
  data() {
    return {
      // center: [110.338686, 25.241744],
    };
  },
  computed: {
    ...mapState({
      hospitalInfo: state => state.app.hospitalInfo,
    }),
    center() {
      return this.hospitalInfo.coordinateAddress
        ? this.hospitalInfo.coordinateAddress.split(",")
        : [];
    },
  },
  created() {
    if (!(this.hospitalInfo && this.hospitalInfo.Id)) {
      this.getHospitalInfo();
    }
  },
  methods: {
    ...mapActions(["getHospitalInfo"]),
  },
};
</script>

<style lang="less" scoped>
.map-box {
  position: relative;
  .map-text {
    font-size: 0.35rem;
    position: absolute;
    left: 0;
    height: 1rem;
    bottom: 0.4rem;
    width: 100%;
    padding: 0 0.3rem 0 0.3rem;
    background: #fff;
    z-index: 210;
    background: -webkit-linear-gradient(
      rgba(255, 255, 255, 0),
      rgba(255, 255, 255, 1)
    ); /* Safari 5.1 - 6.0 */
    background: -o-linear-gradient(
      rgba(255, 255, 255, 0),
      rgba(255, 255, 255, 1)
    ); /* Opera 11.1 - 12.0 */
    background: -moz-linear-gradient(
      rgba(255, 255, 255, 0),
      rgba(255, 255, 255, 1)
    );
    background: linear-gradient(
      rgba(255, 255, 255, 0),
      rgba(255, 255, 255, 1)
    ); /* 标准的语法 */
    .text-info {
      position: absolute;
      bottom: -0.2rem;
    }
  }
  .bg {
    content: "";
    position: absolute;
    bottom: 0rem;
    left: 0;
    width: 100%;
    height: 0.45rem;
    background: #fff;
    z-index: 200;
  }
}
</style>
